// extracted by mini-css-extract-plugin
module.exports = {"formSection":"styles_formSection__3ImbB","confirmPasswordRow":"styles_confirmPasswordRow__3h0RF","newPassword":"styles_newPassword__16q9E"};